export { AtnPageDialogComponent as Component } from './page.component'
